<article class="tooltip-layout1"
         (click)="onVoid($event)">

  <div class="tooltip-wrap"
       *ngIf="hun">
    <div class="tooltip-head-box hun">
      <a class="tooltip-close-btn"
         (click)="onClose($event)"></a>
    </div>


    <div *ngFor="let hanja of listSaseungHanja"
         class="tooltip-item">
      <div class="tooltip-hun-box">
        <div class="hanja" [innerHTML]="GetHanjaHtml(hanja.hanja!) | keepHtml"></div>
        <div class="saseung-box">
          <div class="saseung-item"
             *ngFor="let saseung of hanja.saseungs">
            <div class="saseung">
              <span class="saseung-txt">{{ GetSaseungTxt(saseung.saseung) }}</span>
            </div>
            <div class="meaning" [innerHTML]="GetMeaning(saseung) | resize | keepHtml"></div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="getMoreTxt()"
         class="tooltip-item">
      <div class="tooltip-link-box">
        <a class="tooltip-link-btn"
           (click)="onCloseMore($event)">
          <span class="txt more">{{ getMoreTxt() }}</span>
          <span class="txt">전체 보기</span>
          <i class="ic ic-link"></i>
        </a>
      </div>
    </div>

    <div *ngIf="IsLoading"
         class="reload-icon">
      <img src="assets/img/loading_icon.gif">
    </div>

  </div>

</article>
